import { Injectable } from '@angular/core';
import { Fornitore } from '../model/fornitore';

import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Response } from '@angular/http';
import { environment } from '../../environments/environment';

@Injectable()
export class FornitoreServiceService {

  private lst: Array<Fornitore>;
  constructor(private http: HttpClient) {
  }

  public getfornitoribyComodity(id_comodity: number): Observable< Array<Fornitore>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var url = environment.urlbase + "/Api/Fornitori/GetFornitoriByIdComodity/" + id_comodity.toString();

    var lstFornitori = new Array<Fornitore>();
    var fatto = false;
   return this.http.get<Array<Fornitore>>(url, httpOptions);


  };
  public    getfornitoribyId(id_fornitore: number): Observable<Fornitore> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var url = environment.urlbase + "/Api/Fornitori/GetFornitoriById/" + id_fornitore.toString();


    return   this.http.get<Fornitore>(url, httpOptions) ;



  };


  public   getFotofornitoribyId(id_fornitore: number): Observable<string> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var url = environment.urlbase + "/Api/Fornitori/GetFotofornitoribyId/" + id_fornitore.toString();


    return  this.http.get<string>(url, httpOptions);


  };
}



// WEBPACK FOOTER //
// ./src/app/service/fornitore-service.service.ts